import type { MentionMode } from '../../integrations/IntegrationMentions';
import INTEGRATION_MENTIONS, {
  Behaviors,
} from '../../integrations/IntegrationMentions';
import type { Mention } from '../types';
import matchEntityLink from './matchEntityLink';

export const parseMentionId = (mentionId: string) => {
  const [id, anchor] = mentionId.split('#');
  return { id: id || mentionId, anchor };
};

function matchMention(url: string): {
  modes: [MentionMode, ...MentionMode[]];
  value: Mention;
} | null {
  for (const type of Behaviors.Mention) {
    const { mentionType, parseUrl, modes } = INTEGRATION_MENTIONS[type];
    const parseUrlResult = parseUrl(url);
    if (parseUrlResult) {
      const { id, params } = parseUrlResult;
      return {
        modes,
        value: {
          id,
          type: mentionType,
          ...(params ? { params: new URLSearchParams(params).toString() } : {}),
        },
      };
    }
  }

  const matched = matchEntityLink(url);
  return matched ? { modes: ['mention'], value: matched } : null;
}

export default matchMention;
